
// Store
import { createVuexHelpers } from 'vue2-helpers'
// Components
import DomainsSwitcher from '@/components/DomainsSwitcher.vue'
// Vue
import { defineComponent } from 'vue'
// Types
import { VenueInfoState } from '@/types/storeTypes'

export default defineComponent({
	name: 'EventsHeader',

	components: { DomainsSwitcher },

	setup() {
		const { useState } = createVuexHelpers()
		const { venueInfo }: VenueInfoState = useState('venue', ['venueInfo'])

		return { venueInfo }
	}
})
